module.exports = __webpack_public_path__ + "img/series_10.bfafc07e.png";